export default from './comment-form';



// WEBPACK FOOTER //
// ./app/components/comment-form/index.js